import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import LicenseExpiryList from "../components/report/LicenseExpiryList";

const LicenseExpiryReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="License Expiry Report" />

        {/* LicenseExpiryList with export functionality */}
        <div className="license-expiry-report">
          <LicenseExpiryList />
        </div>
      </MasterLayout>
    </>
  );
};

export default LicenseExpiryReport;
